module.exports = __webpack_public_path__ + "static/media/Party Clown.e5b4ec4e.jpg";